import styled from 'styled-components';

import { Stack, IStackProps } from 'shared/components/Stack';

type ITabSizing = 'auto' | 'even';

export interface ITabsProps extends IStackProps {
  tabSizing?: ITabSizing;
}

export const Tabs = ({ className, ...rest }: ITabsProps) => (
  <Tabs.Root className={`tabs ${className}`} direction="row" spacing="8px" {...rest} />
);

Tabs.Root = styled(Stack)<Pick<ITabsProps, 'tabSizing'>>`
  ${({ tabSizing = 'auto' }) =>
    tabSizing === 'even'
      ? `
      > .tab {
        flex-basis: 1px;
        flex-shrink: 0;
        flex-grow: 1;
      }
      `
      : ''}
`;
